var exports = {
  "kL": "xa15a2ab7--881c7d--container",
  "Zu": "xa15a2ab7--881c7d--fixed",
  "vu": "xa15a2ab7--881c7d--active",
  "kY": "xa15a2ab7--881c7d--transition",
  "iE": "xa15a2ab7--881c7d--wrapper",
  "HU": "xa15a2ab7--881c7d--aside",
  "Uo": "xa15a2ab7--881c7d--buttons",
  "x6": "xa15a2ab7--881c7d--button",
};

module.exports = exports;
